// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor_display__text {
    color: var(--color-text);
    flex-shrink: 0;
}

.cursor_display__placeholder {
    color: var(--color-text-muted);
    flex-shrink: 0;
}

.cursor_display__selection {
    color: var(--color-text);
    background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 40%, transparent);
    flex-shrink: 0;
}

.cursor_display__caret {
    display: inline-block;
    width: 2px;
    height: 1.2em;
    background-color: var(--color-accent);
    border-radius: 1px;
    flex-shrink: 0;
    vertical-align: middle;
    animation: cursor-display-blink 1s step-end infinite;
}

@keyframes cursor-display-blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
}

/* Magnifier tooltip */

.cursor_display__magnifier {
    position: fixed;
    background-color: var(--color-bg-2);
    border: 1px solid var(--color-border);
    border-radius: 10px;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.45);
    pointer-events: none;
    z-index: 2000;
    overflow: hidden;
}

/* Downward-pointing arrow under the magnifier */

.cursor_display__magnifier_arrow {
    position: absolute;
    bottom: -9px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-top: 9px solid var(--color-border);
}

.cursor_display__magnifier_arrow::after {
    content: "";
    position: absolute;
    top: -10px;
    left: -8px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid var(--color-bg-2);
}

/* Scrollable text area inside the magnifier — overflow:hidden so the
   browser clips the content but we can still set scrollLeft programmatically */

.cursor_display__magnifier_scroll {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    white-space: nowrap;
    /* Wide horizontal padding so there's always content to center on */
    padding: 0 200px;
    box-sizing: border-box;
}

.cursor_display__mag_text {
    color: var(--color-text);
    font-size: 22px;
    flex-shrink: 0;
}

.cursor_display__mag_placeholder {
    color: var(--color-text-muted);
    font-size: 22px;
    flex-shrink: 0;
}

/* Long-press context menu */

.cursor_display__ctx_backdrop {
    position: fixed;
    inset: 0;
    z-index: 200;
}

.cursor_display__ctx_menu {
    position: fixed;
    z-index: 201;
    display: flex;
    align-items: stretch;
    height: 36px;
    background-color: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
}

.cursor_display__ctx_item {
    flex: 1;
    padding: 0 12px;
    background: none;
    border: none;
    color: var(--color-text);
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;
}

.cursor_display__ctx_item:active {
    background-color: var(--color-border);
}

.cursor_display__ctx_divider {
    width: 1px;
    background-color: var(--color-border);
    flex-shrink: 0;
}

.cursor_display__mag_caret {
    display: inline-block;
    width: 2px;
    height: 1.2em;
    background-color: var(--color-accent);
    border-radius: 1px;
    flex-shrink: 0;
    vertical-align: middle;
    /* No blinking — steady caret in magnifier */
    opacity: 1;
}

/* Multi-line mode: text wraps instead of scrolling horizontally */

.cursor_display--multiline {
    white-space: pre-wrap;
    word-break: break-word;
}

.cursor_display--multiline .cursor_display__text {
    white-space: pre-wrap;
    word-break: break-word;
    flex-shrink: unset;
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/CursorDisplay/s.cursor_display.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,mFAAmF;IACnF,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,oDAAoD;AACxD;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,UAAU,EAAE;AACtB;;AAEA,sBAAsB;;AAEtB;IACI,eAAe;IACf,mCAAmC;IACnC,qCAAqC;IACrC,mBAAmB;IACnB,0CAA0C;IAC1C,oBAAoB;IACpB,aAAa;IACb,gBAAgB;AACpB;;AAEA,gDAAgD;;AAEhD;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,uCAAuC;AAC3C;;AAEA;+EAC+E;;AAE/E;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mEAAmE;IACnE,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA,4BAA4B;;AAE5B;IACI,eAAe;IACf,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,mCAAmC;IACnC,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,4CAA4C;IAC5C,UAAU;AACd;;AAEA,kEAAkE;;AAElE;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;AACtB","sourcesContent":[".cursor_display__text {\n    color: var(--color-text);\n    flex-shrink: 0;\n}\n\n.cursor_display__placeholder {\n    color: var(--color-text-muted);\n    flex-shrink: 0;\n}\n\n.cursor_display__selection {\n    color: var(--color-text);\n    background-color: color-mix(in srgb, var(--color-accent, #4a6cf7) 40%, transparent);\n    flex-shrink: 0;\n}\n\n.cursor_display__caret {\n    display: inline-block;\n    width: 2px;\n    height: 1.2em;\n    background-color: var(--color-accent);\n    border-radius: 1px;\n    flex-shrink: 0;\n    vertical-align: middle;\n    animation: cursor-display-blink 1s step-end infinite;\n}\n\n@keyframes cursor-display-blink {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0; }\n}\n\n/* Magnifier tooltip */\n\n.cursor_display__magnifier {\n    position: fixed;\n    background-color: var(--color-bg-2);\n    border: 1px solid var(--color-border);\n    border-radius: 10px;\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.45);\n    pointer-events: none;\n    z-index: 2000;\n    overflow: hidden;\n}\n\n/* Downward-pointing arrow under the magnifier */\n\n.cursor_display__magnifier_arrow {\n    position: absolute;\n    bottom: -9px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border-left: 9px solid transparent;\n    border-right: 9px solid transparent;\n    border-top: 9px solid var(--color-border);\n}\n\n.cursor_display__magnifier_arrow::after {\n    content: \"\";\n    position: absolute;\n    top: -10px;\n    left: -8px;\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-top: 8px solid var(--color-bg-2);\n}\n\n/* Scrollable text area inside the magnifier — overflow:hidden so the\n   browser clips the content but we can still set scrollLeft programmatically */\n\n.cursor_display__magnifier_scroll {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    /* Wide horizontal padding so there's always content to center on */\n    padding: 0 200px;\n    box-sizing: border-box;\n}\n\n.cursor_display__mag_text {\n    color: var(--color-text);\n    font-size: 22px;\n    flex-shrink: 0;\n}\n\n.cursor_display__mag_placeholder {\n    color: var(--color-text-muted);\n    font-size: 22px;\n    flex-shrink: 0;\n}\n\n/* Long-press context menu */\n\n.cursor_display__ctx_backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 200;\n}\n\n.cursor_display__ctx_menu {\n    position: fixed;\n    z-index: 201;\n    display: flex;\n    align-items: stretch;\n    height: 36px;\n    background-color: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);\n}\n\n.cursor_display__ctx_item {\n    flex: 1;\n    padding: 0 12px;\n    background: none;\n    border: none;\n    color: var(--color-text);\n    font-size: 13px;\n    font-family: inherit;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.cursor_display__ctx_item:active {\n    background-color: var(--color-border);\n}\n\n.cursor_display__ctx_divider {\n    width: 1px;\n    background-color: var(--color-border);\n    flex-shrink: 0;\n}\n\n.cursor_display__mag_caret {\n    display: inline-block;\n    width: 2px;\n    height: 1.2em;\n    background-color: var(--color-accent);\n    border-radius: 1px;\n    flex-shrink: 0;\n    vertical-align: middle;\n    /* No blinking — steady caret in magnifier */\n    opacity: 1;\n}\n\n/* Multi-line mode: text wraps instead of scrolling horizontally */\n\n.cursor_display--multiline {\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.cursor_display--multiline .cursor_display__text {\n    white-space: pre-wrap;\n    word-break: break-word;\n    flex-shrink: unset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
